import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { PaymentApi } from '../api/payment.api';
import { switchMap, map } from 'rxjs/operators';

import { PaymentDetail,PaymentData, Payment ,PaymentSearchData} from '../../../interfaces/masters/payment' ;
@Injectable()
export class PaymentService extends PaymentData {
  
    private paymentSearchData: PaymentSearchData;
    private taskName:string;

    getPaymentSearchData(): PaymentSearchData {
      return this.paymentSearchData;
    }
    getTaskName():string{
      return this.taskName;
    }

    isAnySearchDataAvailable(): boolean {
      return this.paymentSearchData != null;
    }  

    deletePaymentSearchData(): void {
      delete this.paymentSearchData;
    }

    setPaymentSearchData( paymentSearchData: PaymentSearchData,task:string): void {
      this.paymentSearchData = paymentSearchData;
      this.taskName=task;
    }

    constructor(private api:PaymentApi) {
      super();
    }
  
  
    list(url: string): Observable<Payment[]> {
      return this.api.list(url);
    }
    detailList(url: string): Observable<PaymentDetail[]> {
      return this.api.list(url);
    }
 searchList(url: string,data:any): Observable<any> {
      
      return this.api.searchList(url,data);
    }
    frontList(url: string): Observable<any> {
      return this.api.list(url);
    }
  
    getById(url:string): Observable<Payment>{
        return this.api.getById(url);
    }
     getOtherById(url:string): Observable<any>{
        return this.api.getOtherById(url);
    }
  getByDetailId(url:string): Observable<PaymentDetail>{
        return this.api.getByDetailId(url);
    }
  
    create(url: string, data:Payment): Observable<Payment[]> {
      
      return this.api.add(url,data);
    }
	createForAny(url: string, data:any): Observable<any> {
      
      return this.api.addAny(url,data);
    }
    createDetail(url: string, data:PaymentDetail): Observable<PaymentDetail[]> {
     
      return this.api.addDetail(url,data);
    }

    createDetailMultiple(url: string, data:PaymentDetail[]): Observable<PaymentDetail[]> {

      return this.api.addDetailMultiple(url,data);
    }

    updateothersincome(url: string, data:any): Observable<any> {
      return this.api.updateothersincome(url,data);
    }

    update(url: string, data:Payment): Observable<Payment> {
      return this.api.update(url,data);
    }
  updateDetail(url: string, data:PaymentDetail): Observable<PaymentDetail> {
      return this.api.updateDetail(url,data);
    }
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
  
    
    deleteDetail(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
  }
  